import { rusDeclination } from 'view/molecules/HeaderComponents/SearchList/utils/utils';
import {
  CITY_DECLINATION_ARR_RU,
  CITY_DECLINATION_ARR_ENG,
} from '../config/constants';

export const calculateDeclinationResultTitle = (
  num: number = 0,
  str: string,
  language: string,
) => {
  let resultStr = str;

  if (language === 'ru') {
    resultStr = rusDeclination(num, CITY_DECLINATION_ARR_RU);
  }

  if (language === 'en') {
    resultStr = rusDeclination(num, CITY_DECLINATION_ARR_ENG);
  }

  return `${num} ${resultStr}`;
};
